<template>
    <v-card elevation="6" class="base-card-container pa-5 mt-4">

        <v-row v-if="active">
            <!-- TODO:  -->
            <v-col cols="12" md="12">
                <checkBoxesCard style="height: 100% !important" cardTitle="Judicialización"
                    :checkBoxesInfo="judicializacionInfo" :subTitlesData="subTitlesDataJudicial"
                    :extraDataInfo="extraJudicializacionInfo" fatherColumSize="12"></checkBoxesCard>
            </v-col>
        </v-row>

        <!--Movimientos-->
        <v-row>
            <v-col cols="12" md="12">
                <Movimientos></Movimientos>
            </v-col>
        </v-row>


    </v-card>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import reporteRLV from "@/services/RLV/RLV.service.js";
import checkBoxesCard from "@/components/pages/RLV/components/checkBoxesCard.vue";
import tramitesButtons from "@/components/pages/Shared/components/tramites-buttons.vue";
import Movimientos from "@/components/pages/General/Movimientos/VerMovimientos.vue";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: { checkBoxesCard, tramitesButtons, Movimientos },
    data() {
        return {
            checkbox: false,
            denunciaQuerellaInfo: [],
            extraDataDenunicaInfo: [],
            subTitlesDataDenuncia: [],

            judicializacionInfo: [],
            extraJudicializacionInfo: [],
            subTitlesDataJudicial: [],

            tramitesOptions: [],
            setLoading: 0,

            checkCalidad: false,
            checkConclusion: false,
            active: false,
            datos: null
        };
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    async mounted() {
        this.changeReporteMenuOption(this.$route.name);
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.datos.urlname = this.$route.name;
        await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, "reporte");
        this.ObtenerJuciosOralesInfo();
        //this.ObtenerCatalogoMovimientos();
        this.ObtenerCatalogoMovimientosJudicializacion();
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        async ObtenerCatalogoMovimientos() {
            //    let response = await reporteExpJur.ObtenerCatalogoMovimientos(
            //  this
            //);
            //this.denunciaQuerellaInfo = response;
        },

        async ObtenerCatalogoMovimientosJudicializacion() {
            let response = await reporteRLV.ObtenerCatalogoMovimientosJudicializacion(
                this
            );
            this.judicializacionInfo = response;
            const subTitulos = [...new Set(response.map((item) => item.Tipo))];
            this.subTitlesDataJudicial = subTitulos;

            this.active = true;
        },
        async ObtenerJuciosOralesInfo() {
            let responsJudicial =
                await reporteExpJur.ObtenerCatalogoJuiciosOralesExtraInfo(this.datos, 8, 1);
            this.extraJudicializacionInfo = responsJudicial;

        }
    },
};
</script>
@import
url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;800&display=swap');

<style>
.vs-collapse-item--header {
    background-color: #536dfe !important;
}
</style>

<style scoped>
.base-card-container {
    width: 100%;
    height: 100%;
}

.primerAtencion-container {
    background-color: white;
}

.title-card-style {
    padding: 1.5px !important;
}

.text-subtitle {
    font-family: "Poppins", sans-serif;
    font-size: 0.9em;
}

.card-title-text {
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 1em;
    color: white;
}

.label-text {
    font-family: "Roboto", sans-serif;
    font-weight: 700 !important;
    font-size: 12px !important;
}

.label-text2 {
    font-family: "Roboto", sans-serif;
    font-weight: 700 !important;
    font-size: 16px !important;
}

.checkbox-title-text {
    font-family: "Roboto", sans-serif;
    font-weight: 800 !important;
    font-size: 16px !important;
    color: #adb9ff;
}

.buttons-for-checks {
    margin-bottom: 3px !important;
}

.movimiento-style-text {
    font-family: "Roboto", sans-serif;
    font-weight: 600 !important;
    font-size: 14px !important;
}

.checkbox-section-subtitle {
    font-family: "Roboto", sans-serif;
    font-weight: 800 !important;
    font-size: 14px !important;
    color: #004919;
}
</style>
